import React, { useState, useEffect } from "react";
import { Image } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../components/includes/Common";
import DefaultNav from "../components/navbars/DefaultNav";
import ContactForm from "../components/forms/ContactForm";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var ContactUs = function ContactUs() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(DefaultNav, {})
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        background: "#FFF9F1",
        padding: "24px 12px"
      },
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 6,
            sm: 8,
            children: /*#__PURE__*/_jsx(ContactForm, {})
          }), /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Image, {
              preview: false,
              src: "drawables/cimg.png",
              style: {
                width: "70%"
              }
            })
          })]
        })
      })
    })]
  });
};

export default ContactUs;